import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";

export default function VisionMissionSection() {
  return (
    <section className="sun-glaze bg-secondary-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <Reveal>
            <div className="h-full bg-background-50 rounded-lg border border-secondary-200 p-8 md:p-10 flex flex-col">
              <SunAccent className="mb-5" circleClassName="w-8 h-8" iconClassName="text-base" />
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.24em] uppercase text-secondary-700">
                <i className="ri-eye-line text-base"></i>
                Our Vision
              </span>
              <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 leading-snug font-semibold mt-5">
                To create a world where people are connected to the farmers, land, food, and
                communities that sustain them.
              </h3>
              <p className="text-base text-foreground-600 leading-relaxed mt-6 flex-1">
                We envision a future where rural communities can share their knowledge, culture,
                farms, and stories with visitors while creating meaningful economic opportunities.
              </p>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="h-full bg-primary-900 rounded-lg p-8 md:p-10 flex flex-col">
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
                <i className="ri-flag-line text-base"></i>
                Our Mission
              </span>
              <h3 className="font-heading text-2xl md:text-3xl text-background-50 leading-snug font-semibold mt-5">
                To make agriculture and rural life accessible, experiential, and meaningful for
                everyone.
              </h3>
              <p className="text-base text-background-200 leading-relaxed mt-6">
                Through technology and human connection, Rythugaru aims to build a trusted platform
                connecting:
              </p>
              <div className="flex flex-wrap items-center gap-x-2 gap-y-3 mt-6">
                {["Farmers", "Farms", "Experiences", "People", "Communities"].map((tag, i, arr) => (
                  <div key={tag} className="flex items-center gap-2">
                    <span className="bg-primary-800 text-background-100 text-sm font-medium px-4 py-2 rounded-full border border-primary-700">
                      {tag}
                    </span>
                    {i < arr.length - 1 && <i className="ri-add-line text-accent-400"></i>}
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}